import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Image } from 'foundations-components/transitional/components/Image';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AppCard({
  appCard,
  showBottomBorder
}) {
  const {
    name,
    data: {
      description,
      previewImage,
      eligibleLocations
    }
  } = appCard;
  const locationTranslations = useMemo(() => eligibleLocations === null || eligibleLocations === void 0 ? void 0 : eligibleLocations.map(location => {
    return unescapedText(`detailsPage.functionalityCard.tabs.appCards.locations.${location}`);
  }), [eligibleLocations]);
  return /*#__PURE__*/_jsx(View, {
    borderBlockEndWidth: showBottomBorder ? '100' : undefined,
    borderBlockEndColor: showBottomBorder ? 'border-core-default' : undefined,
    borderBlockEndStyle: showBottomBorder ? 'solid' : undefined,
    paddingBlock: "400",
    children: /*#__PURE__*/_jsxs(Grid, {
      children: [/*#__PURE__*/_jsxs(GridItem, {
        size: {
          sm: 12,
          md: 7
        },
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(BreakString, {
            children: name
          })
        }), /*#__PURE__*/_jsx(Text, {
          whiteSpace: "pre-line",
          children: /*#__PURE__*/_jsx(BreakString, {
            children: description
          })
        }), /*#__PURE__*/_jsx(View, {
          paddingBlockStart: "200",
          children: /*#__PURE__*/_jsxs(Text, {
            children: [/*#__PURE__*/_jsx(Text, {
              typography: "heading-50",
              as: "span",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "detailsPage.functionalityCard.tabs.appCards.placement"
              })
            }), locationTranslations === null || locationTranslations === void 0 ? void 0 : locationTranslations.join(', ')]
          })
        })]
      }), previewImage && previewImage.url && /*#__PURE__*/_jsx(GridItem, {
        size: {
          sm: 12,
          md: 5
        },
        children: /*#__PURE__*/_jsx(Image, {
          alt: previewImage.altText,
          src: previewImage.url,
          responsive: true,
          shape: "rounded"
        })
      })]
    })
  });
}